export class DployContextStore {
}
//# sourceMappingURL=DployContextStore.js.map